<template>
    <div class="MMyachievement" v-if="init">
        <Pull :pull="pull" :page="page" @getList="getMyCertInfo">
            <NoData v-if="!list.length"></NoData>
            <div class="list" v-else>
                <div class="item" @click="openCertfileurl(item)" v-for="(item, index) in list" :key="index">
                    <img v-lazy="item.certfileurl" alt="">
                    <p class="time">{{item.certtime}}获得</p>
                </div>
            </div>
        </Pull>
        <van-overlay :show="show" class="certfileurlPop" @click="show = false">
            <div class="wrapper" @click.stop>
                <img class="certfileurl" :src="certfileurl" alt="">
                <p class="tips">长按保存图片至相册</p>
                <img class="close" @click="show = false" :src="require('@/common/images/other/close.png')" alt="">
            </div>
        </van-overlay>
    </div>
</template>
<script>
import Pull from 'views/mobile/components/pull/pull'
import NoData from 'views/mobile/components/noData/noData'
import {getMyCertInfo} from 'api/personalCenterApi'
import {mapActions, mapGetters} from 'vuex'
export default {
    data() {
        return {
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0,
                rowCount: 0
            },
            pull: {
                isLoading: false,
                loading: false,
                error: false,
                finished: false
            },
            show: false,
            list: [],
            init: false,
            certfileurl: ''
        }
    },
    created() {
        // this.getMyCertInfo()
        document.title = '我的成就'
    },
    mounted() {
        this.setNoDataTip('当前暂无成就')
        if (!this.refresh) {
            this.getMyCertInfo()
        }
    },
    activated () {
        if (this.refresh) {
            this.setNoDataTip('当前暂无成就')
            this.getMyCertInfo()
            this.setRefresh(false)
        }
    },
    methods: {
        openCertfileurl(item) {
            this.certfileurl = item.certfileurl
            this.show = true
            console.log(item)
        },
        getMyCertInfo() {
            this.setLoading(true)
            getMyCertInfo({
                data: this.page,
                success: res => {
                    this.setLoading(false)
                    if (this.page.page === 1) {
                        this.pull.isLoading = false
                        this.list = res.data.content
                    } else {
                        this.list = this.list.concat(res.data.content)
                    }
                    this.pull.loading = false
                    this.page.pageCount = res.data.pageinfo.pageCount
                    this.page.rowCount = res.data.pageinfo.rowCount
                    if (this.page.page === this.page.pageCount) {
                        this.pull.finished = true
                    }
                    this.init = true
                    console.log(res)
                },
                error: res => {
                    this.setLoading(false)
                    this.pull.error = true
                    this.pull.loading = false
                    this.$toast.fail(res.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setRefresh',
            'setNoDataTip'
        ])
    },
    computed: {
        ...mapGetters(['refresh'])
    },
    components: {
        Pull,
        NoData
    }
}
</script>
<style lang="scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
        opacity: 0
    }
    .MMyachievement {
        background: #fff;
        height: 100vh;
        color: #333;
        .noData{
            height: 100vh;
            background: #fff;
        }
        .list {
            display: flex;
            flex-wrap: wrap;
            padding: 0.32rem;
            .item {
                width: 3.22rem;
                margin-bottom: 0.32rem;
                &:not(:nth-of-type(2n)) {
                    margin-right: 0.32rem;
                }
                img {
                    width: 3.22rem;
                    height: 5.82rem;
                    margin-bottom: 0.2rem;
                }
                .time {
                    text-align: center;
                    color: #6E7B8E;
                    font-size: 0.28rem;
                }
            }
        }
        .certfileurlPop {
            // display: flex;
            // justify-content: center;
            // align-items: center;
            .wrapper {
                text-align: center;
                // position: relative;
                // width: 100%;
                // height: 100%;
                .certfileurl {
                    width: 5.46rem;
                    margin: 0.82rem auto 0.3rem;
                }
                .tips {
                    font-size: 0.28rem;
                    line-height: 0.4rem;
                    color: #fff;
                }
                .close {
                    width: 0.38rem;
                    height: 0.38rem;
                    position: absolute;
                    top: 0.82rem;
                    right: 0.5rem;
                }
            }
        }
    }
</style>